import { useState } from "react";

import Input from "@usas/ui-web/components/inputs/Input";
import PhoneInput from "@usas/ui-web/components/inputs/InternationalPhoneInput";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import { isValidEmail } from "@usas/ui-web/utils/validation";

const YouthContactForm = ({
  youthContactData,
  onSubmitFormCallback,
  onSecondaryButtonClicked
}) => {
  const [formState, setFormState] = useState({
    youthEmail: youthContactData?.youthEmail || '',
    youthPhoneNumber: youthContactData?.youthPhoneNumber || ''
  });
  const [errorState, setErrorState] = useState({
    youthEmail: '',
    youthPhoneNumber: ''
  });

  const onValueChanged = (fieldKey, value) => {
    setFormState(prev => ({
      ...prev,
      [fieldKey]: value
    }));
    
    // Clear error when user starts typing
    if (errorState[fieldKey]) {
      setErrorState(prev => ({
        ...prev,
        [fieldKey]: ''
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    
    // Email validation (required)
    if (!formState.youthEmail?.trim()) {
      errors.youthEmail = 'Email address is required';
    } else if (!isValidEmail(formState.youthEmail.trim())) {
      errors.youthEmail = 'Please enter a valid email address';
    }
    
    // Phone number validation is handled by PhoneInput component
    // No additional validation needed here unless specific format is required
    
    setErrorState(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm() && onSubmitFormCallback) {
      onSubmitFormCallback(formState);
    }
  };

  const handleSecondaryClick = (e) => {
    e.preventDefault();
    
    if (onSecondaryButtonClicked) {
      onSecondaryButtonClicked(formState);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12">
          <p><strong>Note:</strong><em> We will not share this information or send marketing emails or texts.</em></p>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-6">
          <Input
            label="Your Email (Or a Parent's)*"
            name="youthEmail"
            value={formState.youthEmail}
            error={!!errorState.youthEmail}
            message={errorState.youthEmail}
            autoFocus={true}
            onChange={(value) => onValueChanged('youthEmail', value)}
          />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-6">
          <PhoneInput
            label="Your Phone Number (Optional)"
            name="youthPhoneNumber"
            value={formState.youthPhoneNumber}
            error={!!errorState.youthPhoneNumber}
            message={errorState.youthPhoneNumber}
            onChange={(value) => onValueChanged('youthPhoneNumber', value)}
          />
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12 usas-extra-top-margin">
          <PrimaryButton type="submit">Continue</PrimaryButton>&nbsp;
          <SecondaryButton type='button' onClick={handleSecondaryClick}>Back</SecondaryButton>
        </div>
      </div>
    </form>
  );
};

export default YouthContactForm;